import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
  },
  buttons: {
    padding: 16,
  },
  useSelectedButton: {
    marginTop: 8,
  },
});
